import React from 'react';
import { useProjectConfigContext } from '../../../../../contexts/ProjectConfigContext';
import { usePermitRequestContext } from '../../../../../contexts/PermitRequestContext';
import RadioBtnsContainer from '../../../../../components/form/radios/RadioBtnsContainer';
import RadioOutlineBtn from '../../../../../components/form/radios/RadioOutlineBtn';
import PermitType from '../../../../../types/permit.type';
import addRequestPageLang from '../../../../../data/lang/add-request-page.lang';
import { useTags } from '../../../../../hooks/useTags';


type Props = {
    handleClick: (e: React.MouseEvent<HTMLInputElement>) => void
}

const ZonePermitType = ({ handleClick }: Props) => {

    const { projectConfigState } = useProjectConfigContext();
    const { Formik } = usePermitRequestContext();
    const generateTag = useTags();
    const { values } = Formik;
    const permitType = values.permitType;

    const permitTypes = projectConfigState.addRequestPageConfig.permitTypes;

    const label = generateTag(addRequestPageLang, 'form.permit-types.zone-permit.title-tag');;
    const noLabel = generateTag(addRequestPageLang, 'form.permit-types.zone-permit.options.noLabel');
    const yesLabel = generateTag(addRequestPageLang, 'form.permit-types.zone-permit.options.yesLabel');

    if (!permitTypes.permitByZone) {
        return null;
    }

    return (
        <div className='row'>
            <div className='col-12 col-sm-4'>
                <RadioBtnsContainer label={label}>

                    <RadioOutlineBtn
                        isChecked={permitType !== PermitType.PERMIT_BY_ZONE}
                        label={noLabel}
                        value={PermitType.REGULAR}
                        onClick={handleClick}
                        id="zonePermitNo"
                        name='zonePermit'
                    />

                    <RadioOutlineBtn
                        isChecked={permitType === PermitType.PERMIT_BY_ZONE}
                        label={yesLabel}
                        value={PermitType.PERMIT_BY_ZONE}
                        onClick={handleClick}
                        id="zonePermitYes"
                        name='zonePermit'
                    />

                </RadioBtnsContainer>
            </div>
        </div>
    );
}

export default ZonePermitType;